module.exports = __webpack_public_path__ + "static/img/8.2cb4d3c.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/1/3/6/eng/8.png
// module id = tbAx
// module chunks = 0